import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AGENCY_DETAILS_STORE_KEY, IAgencyDetailsState } from './agency-details-store.state';

const state = createFeatureSelector<IAgencyDetailsState>(AGENCY_DETAILS_STORE_KEY);

export const agencyDetailsState = createSelector(state, (state1: IAgencyDetailsState) => state1.currentAgency);
export const agencySettings = createSelector(state, (state1: IAgencyDetailsState) => state1.settings);
export const agencyCategories = createSelector(state, (state1: IAgencyDetailsState) => state1.categoriesList);
export const agencyUid = createSelector(state, (state1: IAgencyDetailsState) => state1.uid);
export const agencyPhoto = createSelector(state, (state1: IAgencyDetailsState) => state1.currentAgency?.pictureFullPath);
export const isLoading = createSelector(state, (state1: IAgencyDetailsState) => state1.isLoading);
export const isImageLoading = createSelector(state, (state1: IAgencyDetailsState) => state1.isImageLoading);
export const actionResult = createSelector(state, (state1: IAgencyDetailsState) => state1.actionResult);
